import { DeleteOutline, Edit } from '@mui/icons-material';
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import { IconButton, Tooltip } from '@mui/material';
import { GridColumns } from '@mui/x-data-grid-pro';
import React from 'react';

import { ILocalization, ILocalizationToken } from '../../../../../../../application/language/ILocalization';
import { inject } from '../../../../../../../common/container/inject';
import { injectEntityList } from '../../../../../../../common/store/base/injectEntityList';
import { IEntityListStore } from '../../../../../../../common/store/interface/IEntityListStore';
import { IDataTableRowsUI } from '../../../../../../design/dataTable/parts/rows/IDataTableRowsUI';
import { riskTimeFormat } from '../../../../../../../service/date/since';
import { DataTableUI } from '../../../../../../design/dataTable/store/DataTableUI';
import { IDataTableDomain } from '../../../../../../design/dataTable/store/IDataTableDomain';
import { IDataTableUI } from '../../../../../../design/dataTable/store/IDataTableUI';
import { ActiveDirectoryAdminModel } from './ActiveDirectoryAdminModel';
import { ActiveDirectoryRowsUI } from './rows/ActiveDirectoryRowsUI';

export class ActiveDirectoryAdminUI
  extends DataTableUI<ActiveDirectoryAdminModel, any>
  implements IDataTableUI<ActiveDirectoryAdminModel, any>
{
  constructor(
    public domain: IDataTableDomain<ActiveDirectoryAdminModel, any>,
    rows: IDataTableRowsUI<ActiveDirectoryAdminModel, any> | null,
    public activeDirectory: IEntityListStore<ActiveDirectoryAdminModel> = injectEntityList<ActiveDirectoryAdminModel>(
      [],
    ),
    public i18n = inject<ILocalization>(ILocalizationToken),
  ) {
    super(domain, rows);
    this.rows = rows || new ActiveDirectoryRowsUI(this);
  }

  async getColumns(): Promise<GridColumns> {
    this.setActionColumn();
    return [
      {
        headerName: this.i18n.translate('phrases.nameTitle'),
        field: 'name',
        flex: 1,
      },
      {
        headerName: 'URL',
        field: 'url',
        flex: 1,
      },
      {
        field: 'lastSyncDate',
        headerName: this.i18n.translate('phrases.lastSynchronization'),
        flex: 1,
        type: 'Date',
        valueGetter: (params) => {
          return riskTimeFormat(params.value) || null;
        },
      },

      {
        headerName: this.i18n.translate('ad.table.active'),
        field: 'isActive',
        flex: 1,
        type: 'boolean',
      },
    ];
  }

  async setActionColumn() {
    const actionColumn = this.actionColumnSettings.value;
    actionColumn.actionItem = {
      field: 'action',
      headerName: this.i18n.translate('phrases.actions'),
      flex: 0.5,
      minWidth: 60,
      headerAlign: 'center',
      sortable: false,
      disableColumnMenu: true,
      align: 'center',
      renderCell: (row: any) => {
        return (
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              minWidth: 40,
              maxWidth: 60,
            }}
          >
            <Tooltip title={this.i18n.translate('phrases.sync')}>
              <IconButton
                disabled={!this.isCanEdit.value || !this.isCanDelete.value || !row.row.isActive}
                onClick={(event) => {
                  //@ts-ignore
                  this.domain.rootPrivateServices.activeDirectory.server.syncById(row.id);
                }}
              >
                <SyncAltIcon sx={{ cursor: 'pointer', fontSize: '20px', marginRight: '2px' }} />
              </IconButton>
            </Tooltip>
            <Tooltip title={this.i18n.translate('phrases.edit')}>
              <IconButton
                disabled={!this.isCanEdit.value}
                onClick={(event) => this.domain.contextMenuDomain.onEditRow(row)}
              >
                <Edit sx={{ cursor: 'pointer', fontSize: '20px', marginRight: '2px' }} />
              </IconButton>
            </Tooltip>
            <Tooltip title={this.i18n.translate('phrases.delete')}>
              <IconButton
                disabled={!this.isCanDelete.value}
                onClick={(event) => this.domain.contextMenuDomain.onDeleteRow(row)}
              >
                <DeleteOutline sx={{ cursor: 'pointer', fontSize: '20px' }} />
              </IconButton>
            </Tooltip>
          </div>
        );
      },
    };

    this.actionColumnSettings.setValue(actionColumn);
  }
}
